// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { api } from "../Login/axiosConfig";

// const PaymentSuccess = () => {
//     const navigate = useNavigate();

//   useEffect(() => {
//     const orderId = localStorage.getItem("phonepe_order_id");

//     if (!orderId) {
//       alert("Order ID missing");
//       navigate("/subscription-page");
//       return;
//     }

//     api.get(`/phonepe-status/${orderId}/`)
//       .then(res => {
//         const status = res.data?.status;

//         if (status === "COMPLETED") {
//           alert("Payment successful");

//           navigate("/subscription-page", {
//             state: {
//               paymentStatus: "success",
//               paymentId: orderId
//             }
//           });

//         } else if (status === "PENDING") {
//           // ⏳ retry after 2 sec
//           setTimeout(() => window.location.reload(), 2000);

//         } else {
//           alert("Payment failed");

//           navigate("/subscription-page", {
//             state: { paymentStatus: "failed" }
//           });
//         }
//       })
//       .catch(() => {
//         alert("Error verifying payment");
//       });

//   }, []);

//   return <div>Verifying payment...</div>;
// };

// export default PaymentSuccess;

// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { api } from "../Login/axiosConfig";
// import { Box, Typography, Button, CircularProgress } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";

// const PaymentSuccess = () => {
//   const navigate = useNavigate();

//   const [status, setStatus] = useState("LOADING");

// // useEffect(() => {
// //   const orderId = localStorage.getItem("phonepe_order_id");

// //   if (!orderId) {
// //     setStatus("FAILED");
// //     return;
// //   }

// //   let attempts = 0;
// //   const MAX_RETRIES = 10;

// //   const checkStatus = async () => {
// //     try {
// //       const res = await api.get(`/phonepe-status/${orderId}/`);
// //       const paymentStatus = res.data?.status;

// //       console.log("STATUS:", paymentStatus);

// //       if (paymentStatus === "SUCCESS") {
// //         setStatus("SUCCESS");

// //         const savedData = JSON.parse(
// //           localStorage.getItem("phonepe_payment_data") || "{}"
// //         );

// //         const alreadySaved = localStorage.getItem("phonepe_saved");

// //         // ✅ call API ONLY ONCE
// //         if (!alreadySaved ) {
// //           await api.post("/create_transactions_session_booking/", {
// //             user_id: savedData.user_id,
// //             booking_id: savedData.booking_id,

// //             order_id: orderId,
// //             transaction_id: orderId,

// //             amount: savedData.amount,
// //             status: "success",
// //             payment_reason: "Session Booking"
// //           });

// //           localStorage.setItem("phonepe_saved", "true");
// //         }

// //         // ✅ clear temp data (keep saved flag optional)
// //         localStorage.removeItem("phonepe_order_id");
// //         localStorage.removeItem("phonepe_payment_data");

// //       } else if (paymentStatus === "FAILED") {
// //         setStatus("FAILED");

// //       } else {
// //         // ⏳ PENDING
// //         if (attempts < MAX_RETRIES) {
// //           attempts++;
// //           setTimeout(checkStatus, 3000);
// //         } else {
// //           setStatus("FAILED");
// //         }
// //       }

// //     } catch (err) {
// //       console.error(err);
// //       setStatus("FAILED");
// //     }
// //   };

// //   checkStatus();

// // }, []);

// useEffect(() => {
//   const orderId = localStorage.getItem("phonepe_order_id");

//   if (!orderId) {
//     setStatus("FAILED");
//     return;
//   }

//   let attempts = 0;
//   const MAX_RETRIES = 10;

//   const checkStatus = async () => {
//     try {
//       const res = await api.get(`/phonepe-status/${orderId}/`);
//       console.log("API RESPONSE:", res.data); 
//       const paymentStatus = res.data?.status;
//       const phonepeTxnId = res.data?.data?.transactionId;

//       console.log("STATUS:", paymentStatus);

//       if (paymentStatus === "SUCCESS") {
//         setStatus("SUCCESS");

//         const savedData = JSON.parse(
//           localStorage.getItem("phonepe_payment_data") || "{}"
//         );
//         console.log("SAVED DATA:", savedData);

//         const alreadySaved = localStorage.getItem("phonepe_saved");

//         // 🔥 Prevent duplicate API calls
//         if (!alreadySaved) {

//           // ✅ SESSION BOOKING FLOW
//           if (savedData?.booking_id) {
//             await api.post("/create_transactions_session_booking/", {
//               user_id: savedData.user_id,
//               booking_id: savedData.booking_id,
//               order_id: orderId,
//               transaction_id: orderId,
//               amount: savedData.amount,
//               status: "success",
//               payment_reason: "Session Booking"
//             });
//           }

//           // ✅ SUBSCRIPTION FLOW
//           else if (savedData?.subscription_id) {
            
//             await api.post("/create_transactions_new_subscriptions/", {
//               user_id: savedData.user_id,
//               subscription_id: savedData.subscription_id,
//               order_id: orderId,
//               transaction_id: phonepeTxnId,
//               amount: savedData.amount,
//               final_price: savedData.final_price,
//               original_price: savedData.original_price,
//               status: "success",
//               payment_reason: "Subscription Purchase",
//               plan: savedData.plan,
//               credit_applied: savedData.credit_applied || 0
//             });
//           }

//           else {
//             console.error("❌ No booking_id or subscription_id found");
//           }

//           localStorage.setItem("phonepe_saved", "true");
//         }

//         // 🧹 cleanup
//         localStorage.removeItem("phonepe_order_id");
//         localStorage.removeItem("phonepe_payment_data");

//       } else if (paymentStatus === "FAILED") {
//         setStatus("FAILED");

//       } else {
//         // ⏳ PENDING
//         if (attempts < MAX_RETRIES) {
//           attempts++;
//           setTimeout(checkStatus, 3000);
//         } else {
//           setStatus("FAILED");
//         }
//       }

//     } catch (err) {
//       console.error(err);
//       setStatus("FAILED");
//     }
//   };

//   checkStatus();

// }, []);
//   return (
//     <Box
//       sx={{
//         height: "100vh",
//         background: "linear-gradient(135deg, #0f172a, #020617)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//     >
//       <Box
//         sx={{
//           width: 350,
//           p: 4,
//           borderRadius: 4,
//           textAlign: "center",
//           background: "#111827",
//           boxShadow: "0 10px 40px rgba(0,0,0,0.6)",
//         }}
//       >

//         {/* LOADING */}
//         {status === "LOADING" && (
//           <>
//             <CircularProgress sx={{ color: "#3b82f6" }} />
//             <Typography sx={{ mt: 2, color: "#cbd5f5" }}>
//               Verifying your payment...
//             </Typography>
//           </>
//         )}

//         {/* SUCCESS */}
//         {status === "SUCCESS" && (
//           <>
//             <CheckCircleIcon sx={{ fontSize: 70, color: "#22c55e" }} />
//             <Typography variant="h5" sx={{ mt: 2, color: "#fff", fontWeight: 600 }}>
//               Payment Successful
//             </Typography>

//             <Typography sx={{ mt: 1, color: "#9ca3af" }}>
//               Your subscription is now active 🎉
//             </Typography>

//             <Button
//               variant="contained"
//               sx={{
//                 mt: 3,
//                 bgcolor: "#22c55e",
//                 "&:hover": { bgcolor: "#16a34a" }
//               }}
//               onClick={() => navigate("/subscription-page")}
//             >
//               Go to Dashboard
//             </Button>
//           </>
//         )}

//         {/* FAILED */}
//         {status === "FAILED" && (
//           <>
//             <CancelIcon sx={{ fontSize: 70, color: "#ef4444" }} />
//             <Typography variant="h5" sx={{ mt: 2, color: "#fff", fontWeight: 600 }}>
//               Payment Failed
//             </Typography>

//             <Typography sx={{ mt: 1, color: "#9ca3af" }}>
//               Something went wrong. Please try again.
//             </Typography>

//             <Button
//               variant="contained"
//               sx={{
//                 mt: 3,
//                 bgcolor: "#3b82f6",
//                 "&:hover": { bgcolor: "#2563eb" }
//               }}
//               onClick={() => navigate(-1)}
//             >
//               Try Again
//             </Button>
//           </>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default PaymentSuccess;


import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../Login/axiosConfig";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import Header1 from "../Header/Header1";
import { useAuth } from "../../AuthContext";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { userId } = useAuth();

  const [status, setStatus] = useState("LOADING");
  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    const orderId = localStorage.getItem("phonepe_order_id");

    if (!orderId) {
      setStatus("FAILED");
      return;
    }

    let attempts = 0;
    const MAX_RETRIES = 10;

    const checkStatus = async () => {
      try {
        const res = await api.get(`/phonepe-status/${orderId}/`);
        console.log("API RESPONSE:", res.data);

        const paymentStatus = res.data?.status;
        const phonepeTxnId = res.data?.transaction_id;

        console.log("STATUS:", paymentStatus);

        if (paymentStatus === "SUCCESS") {
          setStatus("SUCCESS");

          const savedData = JSON.parse(
            localStorage.getItem("phonepe_payment_data") || "{}"
          );
          setPaymentData(savedData); 

          console.log("SAVED DATA:", savedData);

          const alreadySaved = localStorage.getItem(`phonepe_saved_${orderId}`);

          if (!alreadySaved) {
            // SESSION BOOKING
            if (savedData?.booking_id) {
              await api.post("/create_transactions_session_booking/", {
                user_id: savedData.user_id,
                booking_id: savedData.booking_id,
                order_id: orderId,
                transaction_id: phonepeTxnId || orderId,
                amount: savedData.amount,
                status: "success",
                payment_reason: "Session Booking",
              });
              console.log("CALLING TRANSACTION API");
            }

            // SUBSCRIPTION
            else if (savedData?.subscription_id) {
              await api.post("/create_transactions_new_subscriptions/", {
                user_id: savedData.user_id,
                subscription_id: savedData.subscription_id,
                order_id: orderId,
                transaction_id: phonepeTxnId || orderId,
                amount: savedData.amount,
                final_price: savedData.final_price,
                original_price: savedData.original_price,
                status: "success",
                payment_reason: "Subscription Purchase",
                plan: savedData.plan,
                credit_applied: savedData.credit_applied || 0,
              });
            } else {
              console.error("❌ No booking_id or subscription_id found");
            }

            localStorage.setItem(`phonepe_saved_${orderId}`, "true");
          }

          // localStorage.removeItem("phonepe_order_id");
          // localStorage.removeItem("phonepe_payment_data");
        } else if (paymentStatus === "FAILED") {
          setStatus("FAILED");
        } else {
          if (attempts < MAX_RETRIES) {
            attempts++;
            setTimeout(checkStatus, 3000);
          } else {
            setStatus("FAILED");
          }
        }
      } catch (err) {
        console.error(err);
        setStatus("FAILED");
      }
    };

    checkStatus();
  }, []);

  return (
    <>
      {/* 🔥 HEADER */}
      <Header1 userId={userId} />

      <Box
        sx={{
          height: "100vh",
          background: "linear-gradient(135deg, #0f172a, #020617)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: 360,
            p: 4,
            borderRadius: 4,
            textAlign: "center",
            background: "#111827",
            boxShadow: "0 10px 40px rgba(0,0,0,0.6)",
          }}
        >
          {/* LOADING */}
          {status === "LOADING" && (
            <>
              <CircularProgress sx={{ color: "#3b82f6" }} />
              <Typography sx={{ mt: 2, color: "#cbd5f5" }}>
                Verifying your payment...
              </Typography>
            </>
          )}

          {/* SUCCESS */}
          {status === "SUCCESS" && (() => {
            const savedData = JSON.parse(
              localStorage.getItem("phonepe_payment_data") || "{}"
            );

            const isSubscription = !!paymentData?.subscription_id;
            const isSession = !!paymentData?.booking_id;

            return (
              <>
                <CheckCircleIcon sx={{ fontSize: 70, color: "#22c55e" }} />

                <Typography
                  variant="h5"
                  sx={{ mt: 2, color: "#fff", fontWeight: 600 }}
                >
                  Payment Successful
                </Typography>

                {/* Dynamic message */}
                <Typography sx={{ mt: 1, color: "#9ca3af" }}>
                  {isSubscription && "Your subscription is now active 🎉"}
                  {isSession && "Your session has been booked successfully 📅"}
                </Typography>

                {/* Info box */}
                <Box
                  sx={{
                    mt: 2,
                    p: 2,
                    borderRadius: 2,
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  {isSubscription && (
                    <Typography sx={{ color: "#22c55e", fontWeight: 600 }}>
                      Plan: {savedData?.plan}
                    </Typography>
                  )}

                  {isSession && (
                    <Typography sx={{ color: "#3b82f6", fontWeight: 600 }}>
                      Session Booking Confirmed
                    </Typography>
                  )}

                  <Typography
                    sx={{ color: "#cbd5f5", fontSize: "0.9rem", mt: 1 }}
                  >
                    Amount Paid: ₹{paymentData?.amount}
                  </Typography>
                </Box>

                {/* Action button */}
                <Button
                  variant="contained"
                  sx={{
                    mt: 3,
                    bgcolor: isSubscription ? "#22c55e" : "#3b82f6",
                    "&:hover": {
                      bgcolor: isSubscription ? "#16a34a" : "#2563eb",
                    },
                  }}
                  onClick={() =>
                    navigate(
                      isSubscription
                        ? "/transactions"
                        : "/transactions"
                    )
                  }
                >
                  {isSubscription
                    ? "View Transactions"
                    : "View Transactions"}
                </Button>
              </>
            );
          })()}

          {/* FAILED */}
          {status === "FAILED" && (
            <>
              <CancelIcon sx={{ fontSize: 70, color: "#ef4444" }} />

              <Typography
                variant="h5"
                sx={{ mt: 2, color: "#fff", fontWeight: 600 }}
              >
                Payment Failed
              </Typography>

              <Typography sx={{ mt: 1, color: "#9ca3af" }}>
                Something went wrong. Please try again.
              </Typography>

              <Button
                variant="contained"
                sx={{
                  mt: 3,
                  bgcolor: "#3b82f6",
                  "&:hover": { bgcolor: "#2563eb" },
                }}
                onClick={() => navigate(-1)}
              >
                Try Again
              </Button>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default PaymentSuccess;

